import { config } from './lib/config.js';

const appRoot = document.getElementById('app-root');

async function startDashboard(user, workspace) {
  document.body.classList.remove('auth-mode');
  appRoot.replaceChildren(...document.getElementById('dashboard-template').content.cloneNode(true).childNodes);
  const { state } = await import('./state.js');
  await state.init({
    organizationId: workspace.organizationId || workspace.id,
    userId: user.uid,
    role: workspace.role,
    userEmail: user.email,
    userName: user.displayName || user.email.split('@')[0],
    userAvatar: user.photoURL || ''
  });
  await import('./app.js');
}

async function start() {
  document.documentElement.dataset.appMode = 'production';
  const { getAuthorizedUser, renderAuthScreen } = await import('./auth.js');
  const { user, rejection } = await getAuthorizedUser();

  if (!user) {
    document.body.classList.add('auth-mode');
    renderAuthScreen(appRoot, { initialMessage: rejection });
    return;
  }

  const { getWorkspace, renderWorkspaceOnboarding } = await import('./workspace.js');
  const workspace = await getWorkspace(user);
  if (!workspace) {
    document.body.classList.add('auth-mode');
    renderWorkspaceOnboarding(appRoot, user);
    return;
  }

  await startDashboard(user, workspace);
}

start().catch((error) => {
  console.error(error);
  appRoot.innerHTML = `<main class="startup-error"><h1>${config.appName} could not start</h1><p></p><button type="button">Try again</button></main>`;
  appRoot.querySelector('p').textContent = error instanceof Error ? error.message : 'Unexpected startup error.';
  appRoot.querySelector('button').addEventListener('click', () => window.location.reload());
});
